import {useMutation, useQueryClient} from '@github-ui/react-query'
import {fetchCAPI} from '../utils/fetch-capi'
import {taskByIdApiPath} from '../utils/api-url-helpers'
import {agentTasksQueryKey} from './useTasks'

interface UseDeleteTaskArgs {
  owner?: string
  repo?: string
  taskId?: string
}

export function useDeleteTask({owner, repo, taskId}: UseDeleteTaskArgs) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['deleteTask', owner, repo, taskId],
    mutationFn: async () => {
      if (!taskId) {
        throw new Error('taskId is required')
      }

      // Always use the non-repo-scoped path — the delete endpoint only exists at /agents/tasks/{task_id}
      const path = taskByIdApiPath(taskId)
      await fetchCAPI({
        path,
        method: 'DELETE',
      })
    },
    onSuccess: () => {
      if (!taskId) return

      queryClient.invalidateQueries({queryKey: agentTasksQueryKey})

      if (owner && repo) {
        queryClient.invalidateQueries({queryKey: ['repo-tasks', owner, repo]})
      }
    },
  })
}
